import(/* webpackMode: "eager" */ "/opt/stpi-client/src/app/(index)/leader/[name]/page.tsx");
